<template>
  <div class="screen" :id="`screen-${currentScreenId}`" ref="screen">
    <div class="screen-inner" :class="{ wide: props.wide }">
      <slot />
      <component :modal="modal || undefined" :is="currentScreenId" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useScreenStore } from '@/store/ScreenStore'
import { useAmplitude } from '@outputinc/o-analytics'

const screenStore = useScreenStore()

const { currentScreenId, currentScreenProduct } = storeToRefs(screenStore)
const { track, Events } = useAmplitude()

const props = withDefaults(defineProps<{ modal?: boolean; wide?: boolean }>(), {
  modal: false,
  wide: false
})

onMounted(() => {
  track(Events.CHECKOUT_SUBSCRIPTION_SCREEN_VIEW, {
    id: currentScreenId.value,
    hostname: window.location.host,
    products: [currentScreenProduct.value]
  })
})
</script>
<style lang="scss" scoped>
.screen {
  display: flex;
  height: 100%;
  position: relative;
  transition: bottom 200ms ease-in-out;

  &-inner {
    max-width: $grid-breakpoint-sm;
    width: 100%;
    margin: 0 auto;

    &.wide {
      max-width: none;
    }
  }
}
</style>
